module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('doc-section', {
    attrs: {
      "id": "affix",
      "name": "Affix"
    }
  }, [_c('div', {
    staticClass: "bs-example"
  }, [_c('h3', [_vm._v("\n      The sub-navigation on the RIGHT is a live demo of the affix.\n      "), _c('span', {
    staticClass: "visible-xs-block visible-sm-block"
  }, [_vm._v("(The live demo is hidden in small screens)")]), _vm._v(" "), _c('tooltip', {
    attrs: {
      "trigger": "hover",
      "effect": "fadein",
      "content": "I'm a direction, not jerking off!",
      "placement": "left"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-hand-right pull-right animated shake hidden-xs hidden-sm"
  })])], 1)]), _vm._v(" "), _c('doc-code', {
    attrs: {
      "language": "markup"
    }
  }, [_vm._v("\n    <affix offset=\"50\">\n      <ul>\n        <li>...</li>\n        <li>...</li>\n        <li>...</li>\n      </ul>\n      <a href=\"#\">...</a>\n    </affix>\n  ")]), _vm._v(" "), _c('doc-table', [_c('div', [_c('p', [_vm._v("offset")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("0")])]), _vm._v(" "), _c('p', [_vm._v("Pixels to offset from top of screen when calculating position of scroll.")])])])], 1)
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1c882d9a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1c882d9a!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/example/affixDocs.vue
// module id = 108
// module chunks = 0